import { SvgPoints } from './svgPathParser'
type Points = Array<
  | { x: number; y: number; moveTo?: boolean }
  | {
      x: number
      y: number
      curve: { type: 'arc'; hR: number; wR: number; stAng: number; swAng: number }
    }
  | { x: number; y: number; curve: { type: 'quadratic'; x1: number; y1: number } }
  | {
      x: number
      y: number
      curve: { type: 'cubic'; x1: number; y1: number; x2: number; y2: number }
    }
  | { close: true }
>

// 这里显示声明
const ratioPx2Inch = { value: 100 }

// 将SVG路径信息格式化为pptxgenjs所需要的格式
export const formatPoints = (points: SvgPoints, scale = { x: 1, y: 1 }): Points => {
  return points.map((point) => {
    if (point.close !== undefined) {
      return { close: true }
    } else if (point.type === 'M') {
      return {
        x: (point.x / ratioPx2Inch.value) * scale.x,
        y: (point.y / ratioPx2Inch.value) * scale.y,
        moveTo: true,
      }
    } else if (point.curve) {
      if (point.curve.type === 'cubic') {
        return {
          x: (point.x / ratioPx2Inch.value) * scale.x,
          y: (point.y / ratioPx2Inch.value) * scale.y,
          curve: {
            type: 'cubic',
            x1: ((point.curve.x1 as number) / ratioPx2Inch.value) * scale.x,
            y1: ((point.curve.y1 as number) / ratioPx2Inch.value) * scale.y,
            x2: ((point.curve.x2 as number) / ratioPx2Inch.value) * scale.x,
            y2: ((point.curve.y2 as number) / ratioPx2Inch.value) * scale.y,
          },
        }
      } else if (point.curve.type === 'quadratic') {
        return {
          x: (point.x / ratioPx2Inch.value) * scale.x,
          y: (point.y / ratioPx2Inch.value) * scale.y,
          curve: {
            type: 'quadratic',
            x1: ((point.curve.x1 as number) / ratioPx2Inch.value) * scale.x,
            y1: ((point.curve.y1 as number) / ratioPx2Inch.value) * scale.y,
          },
        }
      }
    }
    return {
      x: (point.x / ratioPx2Inch.value) * scale.x,
      y: (point.y / ratioPx2Inch.value) * scale.y,
    }
  })
}
